"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var assignSmarterApi_1 = require("../mock/assignSmarterApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var assignSmarterApi = {
    parseGoal: function (token, goal) {
        return rest_1.default.post({
            mockFunc: function () { return assignSmarterApi_1.mockParseGoal; },
            url: "".concat(coreServiceUrl, "/assign-smarter/parse-goal"),
            body: { goal: goal },
            token: token,
        });
    },
    generatePath: function (token, goal, tags) {
        return rest_1.default.post({
            mockFunc: function () { return assignSmarterApi_1.mockGeneratePath; },
            url: "".concat(coreServiceUrl, "/assign-smarter/generate-path"),
            body: { goal: goal, tags: tags },
            token: token,
        });
    },
};
exports.default = assignSmarterApi;
